import { Box, DialogActions, Typography } from "@mui/material";
import {
    AdjustmentsFrequency,
    ComputationFrequency,
    ContractPeriodType,
} from "../../../../../requests_cm/gecoContractsService/types";
import { useState } from "react";

import { Formik } from "formik";
import { Toggle } from "../../../../../common/components/Toggle";
import { noop } from "../../../../../common/utils/operations";
import { PrimaryButton } from "../../../../../common/components/CustomButton";
import { FluidButton } from "../../../../../common/components/FluidButton";
import { If } from "../../../../../common/components/If";
import { borderNeutralSecondary, textNeutralSecondary, white } from "../../../../../core/theme";
import { InvoicingPeriodInputs } from "./InvoicingPeriodInputs";
import { InvoicingPeriodFormikData } from "../../../formik/settlementFormikToContractMapper";

const style = {
    container: {
        width: "680px",
        padding: "16px",
        display: "flex",
        flexDirection: "column",
        border: `1px solid ${borderNeutralSecondary}`,
        gap: "16px",
        background: white,
    },
    title: {
        color: textNeutralSecondary,
        fontSize: "16px",
        fontWeight: "600",
    },
    toogleBox: {
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
    },
    fields: {
        display: "flex",
        flexDirection: "row",
        gap: "8px",
    },
};



interface InvoicePeriodBoxProps {
    onSubmit: (formikData: InvoicingPeriodFormikData) => void;
    contractPeriod: ContractPeriodType | undefined;
}

export const InvoicePeriodBox = ({ onSubmit, contractPeriod }: InvoicePeriodBoxProps) => {
    const hasInitialInvoicePeriod =
        !!contractPeriod?.invoicing?.invoice_decomposition ||
        !!contractPeriod?.invoicing?.has_adjustments ||
        !!contractPeriod?.invoicing?.monthly_settlement?.computation_frequency;

    const [hasInvoicePeriod, setHasInvoicePeriod] = useState<boolean>(
        hasInitialInvoicePeriod
    );

    if (!contractPeriod) {
        return null;
    }

    return (
        <Box sx={style.container}>

            <Formik<InvoicingPeriodFormikData>
                validateOnChange={false}
                validateOnBlur={false}
                enableReinitialize
                initialValues={{
                    invoice_decomposition: !!contractPeriod.invoicing?.invoice_decomposition,
                    has_adjustments: !!contractPeriod.invoicing?.has_adjustments,
                    adjustment_frequency: contractPeriod.invoicing?.adjustment_frequency,
                    computation_frequency:
                        contractPeriod.invoicing?.monthly_settlement
                            ?.computation_frequency,
                }}
                onSubmit={(values, { resetForm }) => {
                    try {
                        onSubmit(values);
                    } catch (error) {
                        resetForm();
                    }
                }}
            >
                {({
                    values,
                    handleChange,
                    setFieldValue,
                    resetForm,
                    handleSubmit,
                    dirty,
                }) => (
                    <form onSubmit={handleSubmit}>
                        <Box sx={style.toogleBox}>
                            <Typography
                                style={style.title}
                            >
                                Invoice Period
                            </Typography>
                            <Box
                                onClick={() =>
                                    setHasInvoicePeriod(prev => !prev)
                                }
                            >
                                <Toggle
                                    onChange={setHasInvoicePeriod}
                                    isTrue={hasInvoicePeriod}
                                    name={""}
                                    label={"Enable Invoice Period"}
                                    description=""
                                />
                            </Box>
                        </Box>
                        <If condition={hasInvoicePeriod}>
                            <Box sx={style.fields}>
                                <InvoicingPeriodInputs
                                    hasInvoiceDecomposition={values.invoice_decomposition}
                                    hasAdjustments={values.has_adjustments}
                                    computationFrequency={values.computation_frequency}
                                    adjustmentFrequency={values.adjustment_frequency}
                                    onComputationFrequencyChange={(value: ComputationFrequency) =>
                                        setFieldValue("computation_frequency", value)
                                    }
                                    onAdjustmentFrequencyChange={(value: AdjustmentsFrequency) =>
                                        setFieldValue("adjustment_frequency", value)
                                    }

                                    onToggleInvoiceDecomposition={(isToggle: boolean) => {
                                        setFieldValue("invoice_decomposition", !!isToggle);
                                    }}
                                    onToggleHasAdjustments={(isToggle: boolean) => {
                                        setFieldValue("has_adjustments", !!isToggle);
                                    }}
                                />
                            </Box>
                        </If>
                        <DialogActions>
                            <If condition={dirty}>
                                <PrimaryButton
                                    onClick={() => resetForm()}
                                    text="Reset"
                                    type="button"
                                    color="secondary"
                                />
                                <FluidButton
                                    type="submit"
                                    label={"Save"}
                                    isDisabled={
                                        !values.invoice_decomposition &&
                                        !values.has_adjustments &&
                                        !values.computation_frequency
                                    }
                                    onClick={noop}
                                />
                            </If>
                        </DialogActions>
                    </form>
                )}
            </Formik>
        </Box>
    );
};
